export default __webpack_public_path__ + "33adb7c8aed76dbb0b58617903125de0.svg";